import * as React from 'react';
import styles from './index.less';
import * as ReactDOM from 'react-dom/client';
// import { Modal } from 'antd';
// import { FUtil } from '@freelog/tools-lib';
// import * as AHooks from 'ahooks';
import FWeiXinShare from './FWeiXinShare';

export { buildWxSharePageUrl } from './FWeiXinShare';

interface fWeiXinShareProps {
  configs: {
    title: string;
    desc: string;
    link: string;
    imgUrl: string;
  };
}

function fWeiXinShare({ configs }: fWeiXinShareProps) {
  return new Promise<void>((resolve) => {
    const divRoot = self.document.body;
    const div = self.document.createElement('div') as HTMLDivElement;
    divRoot.appendChild(div);
    const root = ReactDOM.createRoot(div);
    return root.render(
      <FWeiXinShare
        configs={configs}
        onClose={() => {
          resolve();
          setTimeout(() => {
            root.unmount();
            div.remove();
          }, 30);
        }}
      />,
    );
  });
}

export default fWeiXinShare;
